function getMainHost() {
    let key = `mh_${Math.random()}`;
    let keyR = new RegExp(`(^|;)\\s*${key}=12345`);
    let expiredTime = new Date(0);
    let domain = document.domain;
    return domain;

    let domainList = domain.split('.');

    let urlItems = [];
    // 主域名一定会有两部分组成
    urlItems.unshift(domainList.pop());
    // 慢慢从后往前测试
    while (domainList.length) {
        urlItems.unshift(domainList.pop());
        let mainHost = urlItems.join('.');
        let cookie = `${key}=${12345};domain=.${mainHost}`;

        document.cookie = cookie;

        //如果cookie存在，则说明域名合法
        if (keyR.test(document.cookie)) {
            document.cookie = `${cookie};expires=${expiredTime}`;
            return mainHost;
        }
    }
}
var version = "v2";
if (process.env.NODE_ENV == 'development') {
    // var domain = '192.168.2.134';
    // var domain = "127.0.0.1";
    // var domain = '192.168.31.82';
    // let domain = '192.168.31.50';
    var domain = '47.97.4.192';
    var financeUrl = `http://${domain}:4113/api/${version}/finance`;
    var baseUrl = `http://${domain}:4001/api/${version}/base`;
    var payUrl = `http://${domain}:4002/api/${version}/pay`;
    var c2cUrl = `http://${domain}:4004/api/${version}/c2c`;
    var otcUrl = `http://${domain}:4130/api/${version}/otc`;
    var socketUrl = `ws://${domain}:4003/api/${version}/exchange`;
    var exchangeUrl = `http://${domain}:4003/api/${version}/exchange`;
    var walletUrl = `http://${domain}:4010/api/${version}/wallet`;
    var lockUrl = `http://${domain}:4015/api/${version}/lock`;
    var diceUrl = `http://${domain}:4040/api/${version}/dice`;
    var autoTradeUrl = `http://${domain}:4117/api/${version}/quantize`;
    var allmillUrl = `http://${domain}:4133/api/${version}/allmill`;
    var metaUrl = `http://${domain}:4138/api/${version}/meta`;
    var wsdiceUrl = 'ws://' + domain + ':4040';
} else {
    //正式
    var protocol = window.location.protocol;
    var domain = getMainHost();
    // protocol = "https:";
    // var domain = "www.maibi.info"; 
    // domain = 'www.meta-e.me'
    // domain = "cbex.one";
    // domain = "youxuan.men";
    // var domain = "biquan.live";
    // domain = "huoniu.pro";
    // domain = "bikuai.co";
    // domain = "mckez.com";
    //   domain = "meta-e.me";

    //保护措施，不能修改，本地测试不影响
    if (document.domain != "localhost" && document.domain != "127.0.0.1") {
        domain = getMainHost();
    }
    var financeUrl = protocol + `//${domain}/api/${version}/finance`;
    var baseUrl = protocol + `//${domain}/api/${version}/base`;
    var c2cUrl = protocol + `//${domain}/api/${version}/c2c`;
    var exchangeUrl = protocol + `//${domain}/api/${version}/exchange`;
    var socketUrl = (protocol == "http:" ? "ws" : "wss") + `://${domain}/api/${version}/exchange`;
    var walletUrl = protocol + `//${domain}/api/${version}/wallet`;
    var lockUrl = protocol + `//${domain}/api/${version}/lock`;
    var diceUrl = protocol + `//${domain}/api/${version}/dice`;
    var otcUrl = protocol + `//${domain}/api/${version}/otc`;
    var autoTradeUrl = protocol + `//${domain}/api/${version}/quantize`;
    var allmillUrl = protocol + `//${domain}/api/${version}/allmill`;
    var metaUrl = protocol + `//${domain}/api/${version}/meta`;
    var wsdiceUrl = (protocol == 'http:' ? 'ws' : 'wss') + `://${domain}/api/${version}/dice`;
}

//币币交易
let coinTrade = true;
//法币交易
// c2c交易
let c2cTrade = false;
// otc交易
let otcTrade = false;
//游戏
let dice = false;
//炒币机器人/智能量化
let robot = false;
// 币种标签
let coinTags = false;
// c2c买入限制倍数
let c2cBuy = false;
// 手机注册
let phoneRegister = true;
// 邮箱注册
let emailRegister = true;
// 语言 ['zh-CN', 'en-US', 'zh-TW']
let languages = ['zh-CN', 'en-US', 'zh-TW'];
// 计价币种
let rateCoin = 'CNY';
// 初级认证
let primaryCertification = true;
// 高级认证
let seniorCertification = true;
// 普通认证
let ordinaryCertification = false;
// 支付方式 alipay 支付宝 ｜ bank 银行卡 ｜ weixin 微信
let paymentMethods = ['bank', 'alipay', 'weixin'];
// 锁仓
let lock = false;
// loading的文字
let loadingText = "";
// let mainSite = false;
// let isRenBi = false;
// let isYouxuan = false;
// 是否主站MAIBI
if (document.domain.indexOf('mai') != -1) {
    coinTags = true;
    robot = true;
    dice = true;
    c2cTrade = true;
} else if (document.domain.indexOf('renbi.io') != -1) {
    // isRenBi = true;
} else if (document.domain.indexOf('tigercoin.me') != -1) {
    c2cBuy = true;
} else if (document.domain.indexOf('youxuan.men') != -1) {
    // isYouxuan = true;
    c2cTrade = false;
} else if (document.domain.indexOf('bigkane.com') != -1) {
    emailRegister = true;
    phoneRegister = true;
    languages = ['zh-TW', 'en-US'];
    rateCoin = "USD";
    ordinaryCertification = true;
    legalTenderTrade = false;
    paymentMethods = ["bank"];
    otcTrade = true;
} else if (document.domain.indexOf('biquan.live') != -1) {
    c2cTrade = true;
} else if (document.domain.indexOf('blockstore.club') != -1) {
    otcTrade = true;
} else if (document.domain.indexOf('meta') != -1) {
    otcTrade = true;
    emailRegister = true;
    languages = ['zh-CN', 'en-US'];
    otcTrade = true;
    loadingText = "Metaverse";
    ordinaryCertification = true;
} else if (document.domain.indexOf('libra') != -1) {
    otcTrade = true;
    emailRegister = true;
    languages = ['zh-CN', 'en-US'];
    otcTrade = true;
    ordinaryCertification = true;
} else {
    // robot = true;
    // dice = true;
    otcTrade = true;
    c2cTrade = true;
    ordinaryCertification = true;
}

// 普通认证不与初高级认证同时显示
if (ordinaryCertification) {
    primaryCertification = false;
    seniorCertification = false;
} else if (primaryCertification || seniorCertification) {
    ordinaryCertification = false;
}

module.exports = {
    baseUrl,
    // payUrl,
    paymentMethods,
    otcTrade,
    autoTradeUrl,
    diceUrl,
    getMainHost,
    // mainSite,
    // isRenBi,
    allmillUrl,
    metaUrl,
    otcUrl,
    c2cBuy,
    coinTrade,
    coinTags,
    ordinaryCertification,
    primaryCertification,
    seniorCertification,
    c2cTrade,
    robot,
    lock,
    dice,
    rateCoin: rateCoin.toUpperCase(),
    languages,
    emailRegister,
    phoneRegister,
    walletUrl,
    financeUrl,
    c2cUrl,
    lockUrl,
    socketUrl,
    wsdiceUrl,
    exchangeUrl,
    loadingText
};



// WEBPACK FOOTER //
// ./src/config/index.js